export default __webpack_public_path__ + "static/media/Long_Red.c2f8b8ff.png";